import { render, staticRenderFns } from "./CustomerDebtForList.vue?vue&type=template&id=36c7e93e&"
import script from "./CustomerDebtForList.vue?vue&type=script&lang=js&"
export * from "./CustomerDebtForList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports